import React from 'react';
import { X, GraduationCap } from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../../components/ui/popover';
import { Check, ChevronsUpDown } from 'lucide-react';
import { QUALIFICATION_OPTIONS, CERTIFICATION_OPTIONS } from '../register/options';

export const RegisterDoctorEducation = ({ formData, handleChange, hospitalSearchOpen, hospitals, removeFromArray, renderTagSelector, setHospitalSearchOpen, toggleArrayItem }) => (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <GraduationCap className="w-5 h-5 text-[hsl(var(--primary))]" />
        Education & Qualifications
      </h3>

      {renderTagSelector('qualifications', QUALIFICATION_OPTIONS, 'Qualifications *')}

      <div>
        <label className="block text-sm font-medium mb-1.5">Medical School / University</label>
        <input
          name="medical_school"
          type="text"
          value={formData.medical_school}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="All India Institute of Medical Sciences, New Delhi"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1.5">Registration Number</label>
        <input
          name="registration_number"
          type="text"
          value={formData.registration_number}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="MCI-12345"
        />
      </div>

      {renderTagSelector('certifications', CERTIFICATION_OPTIONS, 'Certifications & Board Memberships')}

      {/* Hospital Affiliations */}
      <div>
        <label className="block text-sm font-medium mb-2">Hospital Affiliations</label>
        <p className="text-xs text-gray-500 mb-2">Select hospitals where you practice (only registered hospitals shown)</p>
        
        <Popover open={hospitalSearchOpen} onOpenChange={setHospitalSearchOpen}>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg text-left flex items-center justify-between hover:bg-gray-50"
            >
              <span className="text-sm text-gray-500">
                {formData.hospital_affiliations.length > 0 
                  ? `${formData.hospital_affiliations.length} hospital(s) selected`
                  : 'Search and select hospitals...'}
              </span>
              <ChevronsUpDown className="w-4 h-4 text-gray-400" />
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-[350px] p-0" align="start">
            <Command>
              <CommandInput placeholder="Search hospitals..." />
              <CommandList>
                <CommandEmpty>No hospitals found.</CommandEmpty>
                <CommandGroup className="max-h-48 overflow-y-auto">
                  {hospitals.map(hospital => (
                    <CommandItem
                      key={hospital._id}
                      value={hospital.name}
                      onSelect={() => {
                        toggleArrayItem('hospital_affiliations', hospital.name);
                      }}
                    >
                      <Check
                        className={`mr-2 h-4 w-4 ${
                          formData.hospital_affiliations.includes(hospital.name) ? 'opacity-100' : 'opacity-0'
                        }`}
                      />
                      <div className="flex flex-col">
                        <span className="text-sm">{hospital.name}</span>
                        {hospital.city && (
                          <span className="text-xs text-gray-500">{hospital.city}, {hospital.state}</span>
                        )}
                      </div>
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>

        {formData.hospital_affiliations.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {formData.hospital_affiliations.map((hospital, index) => (
              <Badge
                key={index}
                className="bg-[hsl(var(--primary))] text-white cursor-pointer"
                onClick={() => removeFromArray('hospital_affiliations', index)}
              >
                {hospital} <X className="w-3 h-3 ml-1" />
              </Badge>
            ))}
          </div>
        )}
      </div>
    </div>
);
